export function removeChars(inputString, charsToRemove) {
  if (typeof inputString !== 'string' || typeof charsToRemove !== 'string') return inputString
  const escapedChars = charsToRemove.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
  const regex = new RegExp(`[${escapedChars}]`, 'g')
  return inputString.replace(regex, '')
}

export function includesSigns(inputString, signs) {
  if (typeof inputString !== 'string' || typeof signs !== 'string') return false
  return signs.split('').some(sign => inputString.includes(sign))
}

/**
 * Trims slashes from the start and end of a string, but preserves slashes in the middle.
 *
 * @param {string} input - The input string to be trimmed.
 * @returns {string} - The trimmed string with leading and trailing slashes removed.
 *
 * @example
 *
 * trimSlashes("/example/path/") => "example/path"
 * trimSlashes("///example/path///") => "example/path"
 * trimSlashes("example/path") => "example/path"
 * trimSlashes("/example/path") => "example/path"
 * trimSlashes("example/path/") => "example/path"
 */
export function trimSlashes(input) {
  if (typeof input !== 'string') {
    console.warn('Input not a string')
    return input
  }
  return input.replace(/^\/+|\/+$/g, '')
}

export const trimLastSlash = (string) => {
  if (typeof string !== 'string') {
    console.warn('Is not a string')
    return string
  }

  if (string === '/') {
    return string
  }

  return string.replace(/\/$/, '')
}